export default "__VITE_ASSET__Dx8nwwVE__"